<template>
<common-dialog
  :show.sync="visible"
  title="商户信息"
  class="edit-peer-info-dialog"
>
  <div class="edit-peer-info-dialog-body">
    <div class="form-avatar">
      <div class="avatar-img-box">
        <img v-if="peer.logo || uploadLogoKey" class="avatar-img" :src="uploadLogoKey ? uploadLogoUrl : peer.logo" alt="">
        <img v-else class="avatar-img" src="../../../assets/imgs/new-user/avatar-default.png" alt="">
      </div>
      <div class="avatar-edit-info">
        <div class="edit-btn" @click="handleClickLogoInput">修改头像</div>
        <div class="tips">1M以内，JPG、PNG格式</div>
        <input type="file" class="faraway" id="logo-img" @change="startUploadLogo" accept="image/png,image/jpeg">
      </div>
    </div>
    <div class="form-item">
      <div class="item-label">商户名称</div>
      <div class="item-content peer-name">{{peer.peer_name}}</div>
    </div>
    <div class="form-item">
      <div class="item-label">联系地址</div>
      <div class="item-content address">
        <div class="row">
          <el-select v-model="formInfo.province_code" placeholder="省" @change="formInfo.city_code=''" class="pcd-field">
            <el-option :label="v" :value="k" v-for="(v,k) in pcds[86]" :key="k"></el-option>
          </el-select>

          <el-select v-model="formInfo.city_code" placeholder="市" @change="formInfo.county_code=''" class="pcd-field">
            <el-option :label="v" :value="k" v-for="(v,k) in pcds[formInfo.province_code]" :key="k"></el-option>
          </el-select>

          <el-select v-model="formInfo.county_code" placeholder="区" class="pcd-field">
            <el-option :label="v" :value="k" v-for="(v,k) in pcds[formInfo.city_code]" :key="k"></el-option>
          </el-select>
        </div>
        <div class="row">
          <el-input type="text" class="detail-address-input" v-model="formInfo.detail_address" :maxlength="100"></el-input>
        </div>
      </div>
    </div>
  </div>
  <div class="edit-peer-info-dialog-footer" slot="footer">
    <button @click="visible = false" class="s-btn btn-info btn-lg">取消</button>
    <button @click="submit" class="s-btn btn-blue btn-lg">保存</button>
  </div>
</common-dialog>
</template>

<script>
import CommonDialog from '../../../components/common/modals/common-dialog/common-dialog.vue';
import utils from '../../../libs/utils';
import Http from '../../../libs/http';
import uploadFileService from '../../../services/upload-file-service';
import { ossBase } from '../../../libs/env';

export default {
  components: {
    CommonDialog,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    peer: {
      type: Object,
      default() {
        return {};
      },
    },
    pcds: {
      type: Object,
    },
  },
  data() {
    return {
      visible: this.show,
      uploadLogoKey: '',
      formInfo: {
        province_code: '',
        city_code: '',
        county_code: '',
        detail_address: '',
      },
      logoUploading: false,
    };
  },
  computed: {
    uploadLogoUrl() {
      return ossBase + this.uploadLogoKey;
    },
  },
  watch: {
    visible(newValue) {
      this.$emit('update:show', newValue);
    },
    show(val) {
      this.visible = val;
      if (val) {
        this.init();
      }
    },
  },
  methods: {
    init() {
      this.uploadLogoKey = '';
      this.formInfo.province_code = String(this.peer.province_code);
      this.formInfo.detail_address = this.peer.detail_address;
      // 分步赋值，不然容易渲染不出来
      this.$nextTick()
        .then((vm) => {
          this.formInfo.city_code = String(this.peer.city_code);
          return vm.$nextTick();
        })
        .then((vm) => {
          this.formInfo.county_code = this.peer.county_code ? String(this.peer.county_code) : '';
          return vm.$nextTick();
        });
    },
    handleClickLogoInput() {
      if (!this.logoUploading) {
        this.$el.querySelector('#logo-img').click();
      }
    },
    startUploadLogo() {
      const file = this.$el.querySelector('#logo-img').files[0];
      if (file) {
        const typeList = ['image/jpg', 'image/jpeg', 'image/png'];
        if (file.size >= 1024000 || typeList.indexOf(file.type) === -1) {
          return utils.msg.warning('请选择1M以内的JPG/PNG格式图片');
        }

        this.logoUploading = true;

        uploadFileService.uploadFile(file, false, { noKey: true }).then((res) => {
          this.logoUploading = false;
          this.uploadLogoKey = res;
        }).catch((e) => {
          if (e) console.log(e);
        }).finally(() => {
          this.logoUploading = false;
        });
      }
    },
    submitLogo() {
      return Http.post('/visa_peer_logo_add', {
        id: this.peer.visa_peer_id,
        key: this.uploadLogoKey,
      });
    },
    submit() {
      const newData = utils.extend({}, this.formInfo);

      if (!newData.province_code || !newData.city_code) {
        return utils.msg.warning('请填写联系地址信息');
      }

      if (newData.province_code && newData.city_code && this.pcds[newData.city_code] && !newData.county_code) {
        return utils.msg.warning('请填写联系地址信息');
      }

      if (!newData.detail_address) {
        return utils.msg.warning('请填写联系地址信息');
      }

      newData.province_code = +newData.province_code;
      newData.city_code = +newData.city_code;
      newData.county_code = Number(newData.county_code) || 0;
      Promise.resolve(this.uploadLogoKey ? this.submitLogo() : null).then(() => {
        Http.post('/visa_peer_update', newData).then(
          () => {
            utils.msg.success('修改成功');
            this.visible = false;
            this.$emit('success');
          },
        ).catch((e) => {
          if (e) console.log(e);
        });
      });
    },

  },
};
</script>

<style lang="less" scoped>
.edit-peer-info-dialog{
  /deep/ .el-dialog{
    width: 600px;
  }
}
.edit-peer-info-dialog-body{
  padding: 24px;
  .form-avatar{
    display: flex;
    .avatar-img-box{
      font-size: 0;
      .avatar-img{
        width: 72px;
        height: 72px;
        object-fit: cover;
        border-radius: 50%;
      }
    }
    .avatar-edit-info{
      margin-left: 20px;
      padding-top: 12px;
      .edit-btn{
        width: 88px;
        padding: 0;
        color: #599FFF;
        cursor: pointer;
      }
      .tips{
        margin-top: 8px;
        color: #91999F;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
  .form-item{
    display: flex;
    align-items: flex-start;
    margin-top: 16px;
    .item-label{
      flex-shrink: 0;
      color: #2F333D;
      font-size: 14px;
      margin-right: 14px;
      width: 76px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
    }
    .item-content{
      flex-grow: 1;
      overflow: hidden;
      color: #2F333D;
      font-size: 14px;
      &.peer-name{
        line-height: 40px;
      }
      &.address{
        .row{
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          &:last-child{
            margin-block: 0;
          }
          /deep/ .el-input__inner{
            height: 40px;
          }
          .pcd-field{
            flex: 1;
            margin-right: 12px;
            &:last-child{
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/components/edit-peer-info-dialog.vue